import { useMutation } from "@tanstack/react-query";
import { getCMAApiClient } from "../../apis/comps/cma/api-factories";
import { buildListingMlsKey } from "../../helpers/listing-mls-key";
import { CMA_SCOPE_KEY } from "./cma.key";

type Props = {
  onSuccess?: () => void;
  onSettled?: () => void;
};

export type Params = {
  cmaId: string;
  mlsId: string;
  mlsSource: string;
};

export const CMA_ADD_COMPARABLE_PROPERTY_MUTATION_KEY =
  "cma-add-comparable-property";

export const useAddComparableProperty = (props?: Props) => {
  const { onSuccess, onSettled } = props || {};
  const api = getCMAApiClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { cmaId, mlsId, mlsSource } = params;
      const response = await api.cMAControllerAddComparableProperty({
        id: cmaId,
        mlsId: buildListingMlsKey({
          mlsId,
          mlsSource,
        }),
      });

      return response;
    },
    onError: async (error) => {
      console.error(`Failed to add comparable property`, error);
    },
    onSettled: () => {
      onSettled?.();
    },
    onSuccess: () => {
      onSuccess?.();
    },
    mutationKey: [CMA_SCOPE_KEY, CMA_ADD_COMPARABLE_PROPERTY_MUTATION_KEY],
  });

  return mutation;
};
